import { render, staticRenderFns } from "./RegistrationsTable.vue?vue&type=template&id=3a06021b&scoped=true"
import script from "./RegistrationsTable.vue?vue&type=script&lang=ts"
export * from "./RegistrationsTable.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationsTable.vue?vue&type=style&index=0&id=3a06021b&prod&lang=scss"
import style1 from "./RegistrationsTable.vue?vue&type=style&index=1&id=3a06021b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06021b",
  null
  
)

export default component.exports